import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const LoaderWrapper = styled.div`
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaQueries.tablet} {
    height: 96px;
  }
`
